export function generateHash(stringToHash: string): number {
  // based on java hashCode implementation
  let hash = 0;
  let chr;
  if (stringToHash === undefined || stringToHash.length === 0) return hash;
  for (let i = 0; i < stringToHash.length; i++) {
    chr = stringToHash.charCodeAt(i);
    hash = (hash << 5) - hash + chr;
    hash |= 0;
  }
  return hash;
}
